"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordTitleFieldLogic = void 0;
var record_title_fieldtype_1 = require("./record-title.fieldtype");
Object.defineProperty(exports, "RecordTitleFieldLogic", { enumerable: true, get: function () { return record_title_fieldtype_1.RecordTitleFieldLogic; } });
